module.exports = __webpack_public_path__ + "img/logo10.469520d5.png";